export default __webpack_public_path__ + "static/media/ZiT3aW1NIVazW5IA1XhgwUHrjqD2.d023259a.jpg";